import { h } from 'vue';
import { RouteRecordRaw, RouterView } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/activeplaces',
            component: { render: () => h(RouterView) },
            children: [
                {
                    path: '/activeplaces',
                    name: 'activeplaces',
                    component: () => import("./views/activeplaces.vue")
                }
            ]
        }
    ];
};